import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubCategoryPageRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-category-page',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId',
};
